import React from 'react'
import { Box, Chip, Grid, Typography } from '@mui/material'
import { ApplicationIcon } from '../../components/applications/ApplicationIcon'
import { AppShortcutCard } from '../../components/dashboard/AppShortcutCard'
import { useAuth } from '../../context/AuthContext'
import { getAssignedApplicationLinks } from '../../services/user/sessionSelectors'

const mapSessionApplicationToCard = (application) => ({
  ...application,
  icon: <ApplicationIcon application={application} size={36} />,
  lastAccess: application.permissions.length > 0
    ? `${application.permissions.length} permisos`
    : 'Acceso asignado',
})

export const UserApplications = () => {
  const { session } = useAuth()
  const apps = getAssignedApplicationLinks(session).map(mapSessionApplicationToCard)

  return (
    <Box className="page-fade">
      <Box className="page-heading suite-page-heading-row">
        <Box>
          <Typography variant="h4">Aplicaciones disponibles</Typography>
          <Typography>Accede a los modulos operativos asignados a tu usuario.</Typography>
        </Box>
        <Chip className="suite-status-chip" label={`${apps.length} aplicaciones`} />
      </Box>

      <Grid container spacing={2.4}>
        {apps.length === 0 && (
          <Grid size={{ xs: 12 }}>
            <Typography className="admin-user-empty">Todavía no tienes aplicaciones asignadas.</Typography>
          </Grid>
        )}
        {apps.map((app) => (
          <Grid key={app.id || app.title} size={{ xs: 12, sm: 6, lg: 4, xl: 3 }}>
            <Box className="suite-app-view-card">
              <AppShortcutCard {...app} />
              <Box className="suite-app-view-meta">
                <Chip size="small" className="suite-status-chip" label={app.status} />
                <Typography>{app.lastAccess}</Typography>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  )
}
